/* eslint-disable import/no-cycle */
import React, { FC, useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import {
  CommonProps,
  ICategory,
  minimalTableColumns,
  tableColumns,
} from './constants';
import { TableRowsPanel } from './TableRowsPanel';
import { CategoryName } from './CategoryName';
import { CategoryActions } from './CategoryActions';

interface Props extends CommonProps {
  category: ICategory;
}

export const SingleRow: FC<Props> = ({ category, layer = 0, ...props }) => {
  const [showSubCategories, setShowSubCategories] = useState(false);
  const { isMinimal, selector } = props;

  return (
    <>
      <TableRow hover>
        {[...(isMinimal ? minimalTableColumns : tableColumns)].map((column) => {
          const value = category[column.id];
          const cellProps = {
            key: `${column.id}-${category.id}`,
            align: column.align || 'center',
            'data-label': column.label,
          };

          if (column.id === 'name')
            return (
              <TableCell {...cellProps}>
                <CategoryName
                  layer={layer}
                  selector={selector}
                  category={category}
                  shouldShow={showSubCategories}
                  onToggle={setShowSubCategories}
                />
              </TableCell>
            );

          return (
            <TableCell {...cellProps}>
              {column.format ? column.format(value) : value}
            </TableCell>
          );
        })}
        <TableCell align="center" data-label="Actions">
          <CategoryActions category={category} {...props} />
        </TableCell>
      </TableRow>
      {!!category.child_categories.length && showSubCategories && (
        <TableRowsPanel
          {...props}
          data={category.child_categories}
          layer={layer + 1}
        />
      )}
    </>
  );
};
